import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { TextSliderSharedComponent } from './text.slider.components';

import { DatepickerSharedModule } from '../datepicker/datepicker.module';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        TextSliderSharedComponent
    ],
    imports: [
        CommonModule,
        DatepickerSharedModule,
        NgbDatepickerModule.forRoot(),
        IconSharedModule
    ],
    exports: [
        TextSliderSharedComponent
    ]
})

export class TextSliderSharedModule {}
